import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ScoreCopyTextForDocumentEditor(
    $projectId: ID!
    $brief: BriefInput
    $scoringMethod: ScoringMethodInput
    $generationTool: GenerationToolEnum!
    $text: String!
    $productName: String
    $annotations: [SuggestionAnnotationInput!]
  ) {
    scoreCopyTextForDocumentEditor(
      projectId: $projectId
      brief: $brief
      scoringMethod: $scoringMethod
      generationTool: $generationTool
      text: $text
      productName: $productName
      annotations: $annotations
    ) {
      score
      ageScoreHistogram
      genderScoreHistogram
      contentTaxonomyId
      engagementScoreSupportSize
      isEnterpriseScoreUsed
      language
      scoringMethod {
        id
        name
        type
      }
      secondaryScoringMethod {
        id
        name
        type
      }
    }
  }
`;

export const scoreRewriteText = (
  { projectId, brief, scoringMethod, generationTool, text, productName, annotations },
  options
) => {
  const variables = {
    projectId,
    brief,
    scoringMethod,
    generationTool,
    text,
    productName,
    annotations,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
